import React from "react";
import { exact, number, string } from "prop-types";
import styles from "./BuildingLoadingSchoolRow.module.styl";
import { Card } from "uikit/components";
import { Link } from "react-router-dom";
import TooltipWrapper from "uikit/components/Tooltip/TooltipWrapper";

export default function BuildingLoadingSchoolRow({ schoolData }) {
    const cardContent = (
        <div className={styles.container}>
            <Link to={`/school-summary/${schoolData.id}`} className={styles.schoolName}
                  data-test-name={`building-loading-school-link-${schoolData.id}`}>
                {schoolData.name}
            </Link>
            <div className={styles.row}>
                Телефон:
                {schoolData.phoneNumber !== null && schoolData.phoneNumber !== "" ? (
                    <div className={styles.highlight}>{schoolData.phoneNumber}</div>
                ) : (
                    <div className={styles.grayText}> не указан </div>
                )}
            </div>
            <div className={styles.row}>
                Email:
                {schoolData.email !== null && schoolData.email !== "" ? (
                    <div className={styles.highlight}>{schoolData.email}</div>
                ) : (
                    <div className={styles.grayText}> не указан </div>
                )}
            </div>
        </div>
    );

    return (
        <>
            {schoolData.name.length >= 32 ||
            (schoolData.phoneNumber !== null && schoolData.phoneNumber.length >= 22) ||
            (schoolData.email !== null && schoolData.email.length >= 26) ? (
                <Card borderRadius={"giant"} className={styles.card}>
                    <TooltipWrapper
                        padding={"big"}
                        placement={"bottomRight"}
                        overlayContent={cardContent}
                        trigger={"hover"}
                    >
                        {cardContent}
                    </TooltipWrapper>
                </Card>
            ) : (
                <Card borderRadius={"giant"} className={styles.card}>
                    {cardContent}
                </Card>
            )}
        </>
    );
}

BuildingLoadingSchoolRow.propTypes = {
    schoolData: exact({
        id: number.isRequired,
        name: string.isRequired,
        email: string,
        phoneNumber: string,
    }),
};
